// Class that handle whole Tableau logic
function Audio() {

	this.a = false;
	this.el = false;

	this.createDOM();
	this.canPlayMp3 = this.canPlayMp3();
	this.isPaused = false;
	this.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}

Audio.prototype.createDOM = function () {

	if (this.a == false) {
		this.a = document.createElement('audio');
	}

	if (this.el == false) {
		this.el = $(this.a);
	}

	return this.el;
};

Audio.prototype.play = function (filename) {
	this.applySource(filename);
};

Audio.prototype.applySource = function (filename) {

	// Apply source
	this.el.attr("src", "audio/" + filename + this.getExtension());
	//this.el.attr("loop", "");
	this.a.volume = 1;

	// Play sound (if paused)
	if (!this.isPaused) {
		this.a.play();
	}

};

Audio.prototype.canPlayMp3 = function () {
	return !!(this.a.canPlayType && this.a.canPlayType('audio/mpeg;').replace(/no/, ''));
};

Audio.prototype.getExtension = function () {
	//return !this.canPlayMp3 || this.isFirefox ? ".ogg" : ".mp3";
	return ".wav";
};
